export type LandCoverColorMap = {
    label: string;
    color: string;
    metricKey?: string;
};

export const landCoverMetricColourMap: LandCoverColorMap[] = [
    { label: 'Water', color: '#6B98E1' },
    { label: 'Trees', color: '#4C7F47' },
    { label: 'Grass', color: '#8EB24E' },
    { label: 'Flooded vegetation', metricKey: 'Flooded Vegetation', color: '#8385C8' },
    { label: 'Crops', color: '#D19833' },
    { label: 'Shrub and scrub', metricKey: 'Shrub and Scrub', color: '#D4C556' },
    { label: 'Built', color: '#AD2A21' },
    { label: 'Bare', color: '#A29B8F' },
    { label: 'Snow and ice', metricKey: 'Snow and Ice', color: '#B39DE3' },
    { label: 'Cumulative vegetation area', metricKey: 'Cumulative Vegetation Area', color: '#4C7F47' },
];

export type BiodiversityIntactnessCategory = 'Severely degraded' | 'Degraded' | 'Moderately intact' | 'Intact';
export type BiodiversityIntactnessColor = 'red' | 'orange' | 'green';

export type BiodiversityIntactnessClassification = {
    category: BiodiversityIntactnessCategory;
    color: BiodiversityIntactnessColor;
};

export const getBiodiversityIntactnessClassification = (value: number): BiodiversityIntactnessClassification => {
    if (value > 0.9) {
        return { category: 'Intact', color: 'green' };
    } else if (value > 0.6) {
        return { category: 'Moderately intact', color: 'orange' };
    } else if (value > 0.3) {
        return { category: 'Degraded', color: 'red' };
    } else {
        return { category: 'Severely degraded', color: 'red' };
    }
};
